import { Metamodel } from '../base/model';
import { shellStringResources } from '../../Resources/ShellStringResources';
import { SqlAnalyticsEndpointDataset } from '../dataset/sql-analytics-endpoint.dataset';
import { CopySource } from './copysource';
import { IAttribute } from '../base/annotation';
import { ModelConstants } from '../model-constants';

@Metamodel.model({
    name: ModelConstants.sqlAnalyticsEndpointCopySource,
    display: [],
    tags: { datasetModel: Metamodel.modelFor(SqlAnalyticsEndpointDataset) }
})
export class SqlAnalyticsEndpointCopySource extends CopySource {
    public static readonly QUERY: IAttribute;
    public static readonly QUERY_TIMEOUT: IAttribute;
    public static readonly PARTITION_OPTION: IAttribute;
    public static readonly PARTITION_NAMES: IAttribute;
    public static readonly PARTITION_COLUMN_NAME: IAttribute;
    public static readonly PARTITION_UPPER_BOUND: IAttribute;
    public static readonly PARTITION_LOWER_BOUND: IAttribute;

    @Metamodel.attribute({
        templatable: true,
        association: 'QUERY',
        display: shellStringResources.QueryLabel,
        constraint: {
            required: true
        }
    })
    public query?: string;

    @Metamodel.attribute({
        templatable: true,
        association: 'QUERY_TIMEOUT',
        display: shellStringResources.ModelName_Source_QueryTimeout_Min,
        accepts: ['String'],
        constraint: {
            minimum: 1,
            maximum: 1440
        }
    })
    public queryTimeout?: number = 120;

    @Metamodel.attribute({
        templatable: true,
        association: 'PARTITION_OPTION',
        display: shellStringResources.ModelName_Partition_Option
    })
    public partitionOption?: string = 'None';

    @Metamodel.attribute({
        templatable: true,
        association: 'PARTITION_NAMES',
        display: shellStringResources.ModelName_Partition_Names
    })
    public partitionNames?: string[];

    @Metamodel.attribute({
        templatable: true,
        association: 'PARTITION_COLUMN_NAME',
        display: shellStringResources.ModelName_Partition_ColumnName
    })
    public partitionColumnName?: string;

    @Metamodel.attribute({
        templatable: true,
        association: 'PARTITION_UPPER_BOUND',
        display: shellStringResources.ModelName_Partition_UpperBound
    })
    public partitionUpperBound?: string;

    @Metamodel.attribute({
        templatable: true,
        association: 'PARTITION_LOWER_BOUND',
        display: shellStringResources.ModelName_Partition_LowerBound
    })
    public partitionLowerBound?: string;
}
